module.exports = __webpack_public_path__ + "img/水电缴费.38561e0e.png";